/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSimpleTenantPermissionFromJSON, ApiSimpleTenantPermissionToJSON, } from './ApiSimpleTenantPermission';
import { ApiTenantProviderFromJSON, ApiTenantProviderToJSON, } from './ApiTenantProvider';
export function ApiSimpleTenantFromJSON(json) {
    return ApiSimpleTenantFromJSONTyped(json, false);
}
export function ApiSimpleTenantFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'entityId': !exists(json, 'entityId') ? undefined : json['entityId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'metaDataUrl': !exists(json, 'metaDataUrl') ? undefined : json['metaDataUrl'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'permissions': !exists(json, 'permissions') ? undefined : (json['permissions'].map(ApiSimpleTenantPermissionFromJSON)),
        'provider': !exists(json, 'provider') ? undefined : ApiTenantProviderFromJSON(json['provider']),
    };
}
export function ApiSimpleTenantToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'domain': value.domain,
        'enabled': value.enabled,
        'entityId': value.entityId,
        'id': value.id,
        'metaDataUrl': value.metaDataUrl,
        'name': value.name,
        'permissions': value.permissions === undefined ? undefined : (value.permissions.map(ApiSimpleTenantPermissionToJSON)),
        'provider': ApiTenantProviderToJSON(value.provider),
    };
}
